import {User} from './user.interface';
import {UserStore} from './user.store.interface';

export class MemoryUserStore implements UserStore {
  private cache: { [key: string]: User } = {};

  get(key: string): User {
    return this.cache[key] || {} as User;
  }

  set(key: string, value: User): boolean {
    this.cache[key] = value;
    return true;
  }

  remove(key: string) {
    this.cache[key] = null;
  }
}
